export const AI_FILE_ADD_MUTATION = `
  mutation aiFileAdd($Name: String!, $Content: Upload!) {
    aiFileAdd(Name: $Name, Content: $Content)
  }
`;

export const AI_ATLAS_FILE_ADD_MUTATION = `
  mutation aiFileAdd($Name: String!) {
    aiFileAdd(Name: $Name)
  }
`;

export const AI_FILE_GENERATE_MUTATION = `
  mutation aiFileGenerate {
    aiFileGenerate
  }
`;

export const AI_FILE_RENAME_MUTATION = `
  mutation aiFileRename($Id: Int!, $Name: String!) {
    aiFileRename(Id: $Id, Name: $Name)
  }
`;

export const AI_FILE_REMOVE_MUTATION = `
  mutation aiFileRemove($Id: Int!) {
    aiFileRemove(Id: $Id)
  }
`;

export const AI_FILE_UPLOAD_MUTATION = `
  mutation aiFileUpload($Id: Int!, $Content: Upload!) {
    aiFileUpload(Id: $Id, Content: $Content)
  }
`;

export const AI_FILE_CHANGE_STATUS_MUTATION = `
  mutation aiFileChangeStatus(
    $Id: Int!
    $Status: AiFileStatus!
  ) {
    aiFileChangeStatus(Id: $Id, Status: $Status)
  }
`;

export const AI_FILES_GET_QUERY = `
  query aiFilesGet(
    $Status: Int
    $Limit: Int
    $Offset: Int
    $SortBy: AiFilesGetSortBy
    $SortDir: SortDir
  ) {
    aiFilesGet(
      Status: $Status
      Limit: $Limit
      Offset: $Offset
      SortBy: $SortBy
      SortDir: $SortDir
    ) {
      count
      rows {
        Id
        DateCreate
        DateUpdate
        Status
        Key
        Name
        Comment
      }
    }
  }
`;
